const initialState = {
  complimentary: false,
  category: undefined,
  fees: {},
  subtotal: 0,
  tax: 0,
  total: 0,
  finalized: false,
  validated_membership: false,
  record_id: undefined,
  record_type: undefined
}

function calc(state) {
  let totals = { subtotal: 0, tax: 0, total: 0 };
  if (!state.complimentary) {
    for (var f in state.fees) {
      totals.subtotal += state.fees[f].price*state.fees[f].qty;
    }
    totals.tax = state.tax_rate ? state.tax_rate * totals.subtotal : 0;
    totals.total = totals.subtotal + totals.tax;
  }
  return Object.assign({}, state, totals)
}

export default function form(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_FORM':
      var change = action.change;
      // if the category changes, reset the fees
      if (change.category) {
        change.fees = {};
      }
      return calc(Object.assign({}, state, change));

    case 'INCREASE_FEE_QTY':
      var fees = state.fees;
      fees[action.fee_name] = fees[action.fee_name] || { qty: 0, price: action.price };
      fees[action.fee_name].qty++;
      return calc(Object.assign({}, state, { fees }));

    case 'DECREASE_FEE_QTY':
      var fees = state.fees;
      if (fees[action.fee_name].qty && fees[action.fee_name].qty > 0) {
        fees[action.fee_name].qty--;
        if (fees[action.fee_name].qty == 0) {
          delete fees[action.fee_name];
        }
      }
      return calc(Object.assign({}, state, { fees }));

    case 'CHANGE_COMPLIMENTARY':
      return calc(Object.assign({}, state, { complimentary: action.complimentary }));

    case 'FINALIZE_LOGIN':
      // map logged in member to any matching form fields
      var change = action.change;
      change.record_id = change.id;
      delete change.id;
      change.validated_membership = true;
      return Object.assign({}, state, change)

    case 'FINALIZE_SUBMISSION':
      return Object.assign({}, state, { finalized: true })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/event_render/reducers/form.js